import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from '../shared.modules';

@NgModule({
    imports: [
        SharedModule,
        CommonModule,
        IonicModule,
        TranslateModule.forChild(),
    ],
    declarations: [],
    exports: [
        SharedModule,
        CommonModule,
        IonicModule,
        TranslateModule
    ]
})
export class PagesSharedModule {
}
